import { accountFieldsFragment } from "gql/graphql";
import { isExternalLink } from "ui-library/Link/isExternalLink";

const authentic8Prefix = "https://a8silo.com/launch#";

export function resolveExternalUrl(
	url: string,
	account: accountFieldsFragment | undefined
): string {
	if (
		account?.settings.authentic8 &&
		account.preferences.authentic8 &&
		isExternalLink(url)
	) {
		return `${authentic8Prefix}${url}`;
	}
	return url;
}
